// filepath: cryptobag-com/src/components/SparklineChart.jsx
import React from 'react';
import { LineChart, Line, ResponsiveContainer, Tooltip } from 'recharts';
import { formatCurrency } from '../utils/formatters';

/**
 * SparklineChart Component
 * Renders a mini 7-day chart for the table.
 */
const SparklineChart = ({ data, strokeColor }) => {
  const chartData = data.map((price, index) => ({ price, index }));

  return (
    <div className="w-28 h-10">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData} margin={{ top: 2, right: 0, left: 0, bottom: 2 }}>
          <Tooltip
            contentStyle={{ 
              backgroundColor: 'rgba(20, 20, 20, 0.8)', 
              borderColor: '#555', 
              borderRadius: '8px',
              backdropFilter: 'blur(4px)',
            }}
            labelStyle={{ display: 'none' }}
            itemStyle={{ color: strokeColor }}
            formatter={(value) => [formatCurrency(value), 'Price']}
          />
          <Line
            type="monotone"
            dataKey="price"
            stroke={strokeColor}
            strokeWidth={2}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SparklineChart;